import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import classNames from "classnames";
import styles from "../styles/key-players-widget.scss";

const KeyPlayersWidgetAsyncComponent = AsyncComponent(async () => import('./key-players-widget' /* webpackChunkName: "key-players-widget" */ ));

export const KeyPlayersWidgetAsync = (props) => {
  return <React.Suspense fallback={<div className={classNames(styles.placeholder, props.className)}/>}>
    <KeyPlayersWidgetAsyncComponent {...props}/>
  </React.Suspense>
}
